import * as React from "react";
import styled from "styled-components";
import { ConstColor } from "../../../../../config/styles_const/styles_const";
import MessageRoomOpponentInfo from "../../../../common/organism/message_room/message_room_opponent_info";
import MessageRoomProjectInfo from "../../../../common/organism/message_room/message_room_project_info";
import { ClientMessageRoomState } from "../../../../store/client_message_room_state";

interface IProps {
  messageRoomState: ClientMessageRoomState;
}

const ClientMessageRoomsRight: React.FC<IProps> = (props) => {
  const { messageRoomState } = props;
  const { ownSignature, project, opponentSignature } = messageRoomState;

  if (!ownSignature || !opponentSignature || !project) {
    return null;
  }

  return (
    <React.Fragment>
      <MessageRoomOpponentInfo
        opponentSignature={opponentSignature}
        opponentURL={`/client/customer/${opponentSignature.id}`}
      />
      <Hr />
      <MessageRoomProjectInfo
        project={project}
        companyIcon={ownSignature.iconURL}
        companyName={ownSignature.name}
        projectURL={`/client/project/preview/${project.id}`}
        contractURL={`/client/contract/registration/${project.companyID}/${
          project.id
        }/${messageRoomState.messageRoom!.customerID}`}
        customerId={messageRoomState.messageRoom!.customerID}
        messageRoom={messageRoomState.messageRoom!}
      />
    </React.Fragment>
  );
};

export default ClientMessageRoomsRight;

const Hr = styled.hr`
  height: 1px;
  margin: 0;
  margin-top: 30px;
  margin-bottom: 30px;
  background: ${ConstColor.Hr};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/message_rooms/right/client_message_rooms_right.tsx